/**
 * Subscriptions data reducer and actions
 * @module reducers/subscriptions
 */

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';

// Action creator for getting subscriptions data (GET)
export function getSubscriptions() {
  // console.log('getSubscriptions reducer called')
  return {
    type: GET_SUBSCRIPTIONS,
    request: {
      op: 'get',
      path: '/@subscription/subscriptions_data'
    },
  };
}

// State interface
interface SubscriptionsDataState {
  error: any;
  loaded: boolean;
  loading: boolean;
  data: any[];
}

// Initial state
const initialState: SubscriptionsDataState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

// Reducer
export default function subscriptions(
  state: SubscriptionsDataState = initialState,
  action: any = {}
): SubscriptionsDataState {
  switch (action.type) {
    case `${GET_SUBSCRIPTIONS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SUBSCRIPTIONS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    case `${GET_SUBSCRIPTIONS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}

